import React from 'react'
import { Box } from '@mui/material'

const AdxChip = ({ children, chipBgColor, chipColor, outlined, fullWidth, sx }) => {
  return (
    <Box
      sx={{
        width: fullWidth ? '100%' : 'fit-content',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'start',
        borderRadius: '45px',
        height: '30px',
        p: 1.5,
        color: chipColor,
        backgroundColor: chipBgColor,
        border: outlined && '1px solid',
        borderColor: 'gray-line.main',
        ...sx,
      }}
    >
      {children}
    </Box>
  )
}

export default AdxChip
